<template>
    <div>
        <v-row>
            <v-col
                cols="12"
                :lg="showJobInformation == true && showJobSummary == false ? 12 : 7"
                :md="showJobInformation == true && showJobSummary == false ? 12 : 7"
                sm="12"
                style="padding: 0px !important;"
            >
                <v-card-text>

                    <v-card
                        class="mx-auto"
                    >
                        <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                            Job Information - {{ getIDProjectFormatted() }}
                        </v-card-title>
                        <v-card-text>

                            <v-row>
                                <v-col 
                                    cols="12"
                                    lg="12"
                                    md="12"
                                    sm="12"
                                >
                                    <table style="width: 100%; border: none; margin-top: 10px;">
                                        <tr><td>Created On</td><td colspan="3"> {{ serviceRequest.dateRegisterFormatted }}</td></tr>
                                        <tr><td>Customer</td><td colspan="3"> {{ serviceRequest.customerSelected.fullName }}</td></tr>
                                        <tr><td>Phone</td><td colspan="3"> {{ serviceRequest.phone }}</td></tr>
                                        <tr><td>Email</td><td colspan="3"> <a :href="`mailto:${serviceRequest.email}`">{{ serviceRequest.email }}</a></td></tr>
                                        <tr><td>Address</td>
                                            <td colspan="3"> 
                                                {{ serviceRequest.addressSelected.address }}                                                
                                                <v-tooltip 
                                                    bottom
                                                    v-if="canEditGeoCoding == true"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon 
                                                            v-if="canEditGeoCoding == true"
                                                            v-on="on" 
                                                            color="var(--color__main)"
                                                            @click="viewMapAddress()"
                                                            style="max-height: 30px;"
                                                        >
                                                            mdi mdi-google-maps
                                                        </v-icon>
                                                    </template>
                                                    <span>View Map</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Sales Person</td>
                                            <td colspan="3"> 
                                                {{ serviceRequest.userResponsibleSelected != null && serviceRequest.userResponsibleSelected != undefined ? serviceRequest.userResponsibleSelected.name : '' }}
                                                
                                                <v-tooltip
                                                    top
                                                    v-if="isProfileAdmin"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-if="isProfileAdmin"
                                                            style="width: 45px; max-height: 30px; border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="showDialogSalesPerson()"
                                                        >
                                                            <v-icon v-on="on" small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Update Sales Person</span>
                                                </v-tooltip>

                                            </td>
                                        </tr>
                                        <tr v-if="showCustomerURL"><td>Customer Url</td>
                                            <td colspan="3"> 
                                                <a v-bind:href="serviceRequest.customerUrl" target="_blank">{{ serviceRequest.customerUrl }}</a>
                                                <v-tooltip 
                                                    top
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 45px; max-height: 30px; border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="copyToClipboard(serviceRequest.customerUrl)"
                                                        >
                                                            <v-icon v-on="on" small>mdi-content-copy</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Copy Url</span>
                                                </v-tooltip>
                                                <v-tooltip 
                                                    top
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 45px; max-height: 30px; border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="showQRCode = true"
                                                        >
                                                            <v-icon v-on="on" small>mdi-qrcode</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Generate QR Code</span>
                                                </v-tooltip>

                                                <span><strong>[Pin Code: {{ serviceRequest.pinCode }}]</strong></span>
                                                <v-tooltip 
                                                    top
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 45px; max-height: 30px;border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="copyToClipboard(serviceRequest.pinCode)"
                                                        >
                                                            <v-icon v-on="on" small>mdi-content-copy</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Copy pin code</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                        <tr v-if="showReviewReason"><td style="font-weight: normal !important; color: var(--color__main)">Reason: </td><td style="color: var(--color__main)"> This service has some items that need approval</td></tr>
                                        <tr v-if="showClassification"><td>Classification</td>
                                            <td> 
                                                <v-combobox
                                                    style="height: 45px;"
                                                    v-model="classificationSelected"
                                                    :items="listClassification"
                                                    :rules=[validations.required]
                                                    :disabled="canEditClassification"
                                                    item-text="description"
                                                    item-value="id"
                                                    clearable
                                                    outlined
                                                    dense
                                                    @change="updateClassification()"
                                                ></v-combobox>
                                            </td>
                                        </tr>
                                        <tr v-if="getConstructionSupervisorName != ''"><td>Construction Supervisor</td>
                                            <td> 
                                                {{ getConstructionSupervisorName }}
                                                <v-tooltip 
                                                    v-if="canChangeSupervisor"
                                                    top
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-if="canChangeSupervisor"
                                                            style="width: 45px; max-height: 30px;border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="showDialogSupervisor()"
                                                        >
                                                            <v-icon v-on="on" small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Change Supervisor</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                        <tr v-if="isProfileAdmin && isServiceType == false">
                                            <td>Permit Fee</td>
                                            <td> 
                                                {{ this.serviceRequest.permitFeeFormatted }}%
                                                <v-tooltip
                                                    top
                                                    v-if="isProfileAdmin"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-if="isProfileAdmin"
                                                            style="width: 45px; max-height: 30px;border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="showDialogPermitFee()"
                                                        >
                                                            <v-icon v-on="on" small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Update Permit Fee</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                        <tr v-if="canEditEstimatedBudget && isServiceType == false">
                                            <td style="width: 25%;"><strong>Estimated Budget</strong></td>
                                            <td style="width: 25%;">
                                                <strong>{{ serviceRequest.estimatedBudgetFormatted }}</strong>
                                                <v-tooltip
                                                    top
                                                    v-if="canEditEstimatedBudget"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-if="canEditEstimatedBudget"
                                                            style="width: 45px; max-height: 30px;border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="showDialogEstimatedBudget()"
                                                        >
                                                            <v-icon v-on="on" small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Update Estimated Budget</span>
                                                </v-tooltip>
                                            </td>
                                            <td
                                                v-if="isProfileAdmin && 
                                                    serviceRequest.dateContractFormatted != null && 
                                                    serviceRequest.dateContractFormatted != undefined && 
                                                    serviceRequest.dateContractFormatted != '' && 
                                                    isServiceType == false"
                                                style="width: 25%;"
                                            >
                                                <strong>Contracted Date</strong>
                                            </td>
                                            <td
                                                v-if="isProfileAdmin && 
                                                    serviceRequest.dateContractFormatted != null && 
                                                    serviceRequest.dateContractFormatted != undefined && 
                                                    serviceRequest.dateContractFormatted != '' && 
                                                    isServiceType == false"
                                                style="width: 25%;"
                                            >
                                                <strong>{{ serviceRequest.dateContractFormatted }}</strong>
                                                <v-tooltip
                                                    top
                                                    v-if="isProfileAdmin"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-if="isProfileAdmin"
                                                            style="width: 45px; max-height: 30px;border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="showDialogContractDate()"
                                                        >
                                                            <v-icon v-on="on" small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Update Contracted Date</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                        <tr v-if="isProfileAdmin">
                                            <td style="width: 25%;"><strong>Technical Specification Is Required</strong></td>
                                            <td style="width: 25%;">
                                                <strong>{{ serviceRequest.techSpecIsRequiredDescription }}</strong>
                                                <v-tooltip
                                                    top
                                                    v-if="isProfileAdmin"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-if="isProfileAdmin"
                                                            style="width: 45px; max-height: 30px;border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="showDialogYesNoIsRequired('ts')"
                                                        >
                                                            <v-icon v-on="on" small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Change</span>
                                                </v-tooltip>
                                            </td>
                                            <td style="width: 25%;"><strong>Drafting Is Required</strong></td>
                                            <td style="width: 25%;">
                                                <strong>{{ serviceRequest.draftingIsRequiredDescription }}</strong>
                                                <v-tooltip
                                                    top
                                                    v-if="isProfileAdmin"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-if="isProfileAdmin"
                                                            style="width: 45px; max-height: 30px;border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="showDialogYesNoIsRequired('df')"
                                                        >
                                                            <v-icon v-on="on" small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Change</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                        <tr v-if="isProfileAdmin">
                                            <td style="width: 25%;"><strong>Permitting Is Required</strong></td>
                                            <td style="width: 25%;">
                                                <strong>{{ serviceRequest.permittingIsRequiredDescription }}</strong>
                                                <v-tooltip
                                                    top
                                                    v-if="isProfileAdmin"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-if="isProfileAdmin"
                                                            style="width: 45px; max-height: 30px;border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="showDialogYesNoIsRequired('pm')"
                                                        >
                                                            <v-icon v-on="on" small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Change</span>
                                                </v-tooltip>
                                            </td>
                                            <td style="width: 25%;"><strong>Send Email For Customer Construction Steps</strong></td>
                                            <td style="width: 25%;">
                                                <strong>{{ serviceRequest.sendEmailForCustomerConstructionStepsDescription }}</strong>
                                                <v-tooltip
                                                    top
                                                    v-if="isProfileAdmin"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-if="isProfileAdmin"
                                                            style="width: 45px; max-height: 30px;border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="showDialogYesNoIsRequired('se')"
                                                        >
                                                            <v-icon v-on="on" small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Change</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                        <tr v-if="isProfileAdmin">
                                            <td style="width: 25%;"><strong>Load Calculation Required</strong></td>
                                            <td style="width: 25%;">
                                                <strong>{{ serviceRequest.loadCalculationRequiredDescription }}</strong>
                                                <v-tooltip
                                                    top
                                                    v-if="isProfileAdmin"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-if="isProfileAdmin"
                                                            style="width: 45px; max-height: 30px;border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="showDialogYesNoIsRequired('lc')"
                                                        >
                                                            <v-icon v-on="on" small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Change</span>
                                                </v-tooltip>
                                            </td>
                                            <td style="width: 25%;"><strong>Financing Requirements</strong></td>
                                            <td style="width: 25%;">
                                                <strong>{{ serviceRequest.financeDescription }}</strong>
                                                <v-tooltip
                                                    top
                                                    v-if="isProfileAdmin"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-if="isProfileAdmin"
                                                            style="width: 45px; max-height: 30px;border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="showDialogYesNoIsRequired('fi')"
                                                        >
                                                            <v-icon v-on="on" small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Change</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                    </table>
                                </v-col>
                            </v-row> 
                        </v-card-text>

                    </v-card>
                    
                </v-card-text>

                <JobInformationDocuments
                    v-if="fromTrackerPage == false &&
                          showQuickAccess && 
                          showQuickAccessAsDocument && 
                          projectSelected != null"
                    :id="id"
                    :projectSelected="projectSelected"
                    :serviceRequest="serviceRequest"
                    :title="'Documents'"
                    :isProfileAdmin="isProfileAdmin"
                    :isSalesPerson="isSalesPerson"
                    :surveyFileId="surveyFileId"
                    :surveyFileType="surveyFileType"
                    :surveyFileName="surveyFileName"
                    :poolStudioFileId="poolStudioFileId"
                    :poolStudioFileType="poolStudioFileType"
                    :poolStudioFileName="poolStudioFileName"
                    :colorSelectionFileId="colorSelectionFileId"
                    :colorSelectionFileType="colorSelectionFileType"
                    :colorSelectionFileName="colorSelectionFileName"
                    :draftingListFiles="[]"
                    :addendumListFiles="addendumListFiles"
                    :permittingListFiles="[]"
                />
            </v-col>
            <v-col
                v-if="showJobSummary == true"
                cols="12"
                lg="5"
                md="5"
                sm="12"
                style="padding: 0px !important;"
            >
                <v-card-text>

                    <v-card
                        class="mx-auto"
                    >
                        <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                            Job Total
                        </v-card-title>
                        <v-card-text>
                            
                            <table style="width: 100%; border: none; margin-top: 10px;">
                                <tr v-for="(itemProject, index) in listProjects" :key="index">
                                    <td>{{ itemProject.nameWithVersion }}</td>
                                    <td>{{ itemProject.totalProjectFormatted }}</td>
                                </tr>
                                <tr v-for="(itemAddendum, indexAddendum) in listAddendum" :key="indexAddendum + 100">
                                    <td>Addendum - [{{ indexAddendum + 1 }}]</td>
                                    <td>{{ getTotalAddendum(itemAddendum) }}</td>
                                </tr>
                                <tr v-if="isServiceType == false">
                                    <td class="grandTotal">Discount</td>
                                    <td class="grandTotal">{{ discount }}</td>
                                </tr>
                                <tr v-if="hasCustomItems == true">
                                    <td class="grandTotal">Custom Items</td>
                                    <td class="grandTotal">{{ grandTotalProductsCustomItems.formatted }}</td>
                                </tr>
                                <tr v-if="isServiceType == false">
                                    <td class="grandTotal">Permit Fee</td>
                                    <td class="grandTotal">{{ this.serviceRequest.permitFeeFormatted }}%</td>
                                </tr>
                                <tr v-if="isServiceType == false && serviceRequest.adjustment != 0">
                                    <td class="grandTotal">Grand Total</td>
                                    <td class="grandTotal">{{ serviceRequest.adjustmentFormatted }}</td>
                                </tr>
                                <tr v-else>
                                    <td class="grandTotal">Grand Total</td>
                                    <td class="grandTotal">{{ grandTotal }}</td>
                                </tr>
                            </table>
                            
                        </v-card-text>

                    </v-card>
                    
                </v-card-text>
        
                <JobInformationDocuments
                    v-if="showQuickAccess && showQuickAccessAsDocument == false && projectSelected != null"
                    :id="id"
                    :projectSelected="projectSelected"
                    :serviceRequest="serviceRequest"
                    :isProfileAdmin="isProfileAdmin"
                    :isSalesPerson="isSalesPerson"
                    :surveyFileId="surveyFileId"
                    :surveyFileType="surveyFileType"
                    :surveyFileName="surveyFileName"
                    :poolStudioFileId="poolStudioFileId"
                    :poolStudioFileType="poolStudioFileType"
                    :poolStudioFileName="poolStudioFileName"
                    :colorSelectionFileId="colorSelectionFileId"
                    :colorSelectionFileType="colorSelectionFileType"
                    :colorSelectionFileName="colorSelectionFileName"
                    :draftingListFiles="[]"
                    :addendumListFiles="addendumListFiles"
                    :permittingListFiles="[]"
                />

                <v-card-text v-if="showPayments == true && payment != null && payment != undefined">

                    <v-card
                        class="mx-auto"
                    >
                        <v-card-title v-if="fromTrackerPage == false" class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                            <v-col 
                                cols="9"
                                lg="9"
                                md="9"
                                sm="9"
                            >
                                Payments
                            </v-col>
                            <v-col 
                                style="text-align: right;"
                                cols="3"
                                lg="3"
                                md="3"
                                sm="3"
                            >
                                <v-tooltip
                                    left
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            v-on="on"
                                            large
                                            color="var(--color__main)"
                                            @click="showDialogManagePayments()"
                                        >
                                            mdi-credit-card-settings-outline
                                        </v-icon>
                                    </template>
                                    <span>Manage Payments</span>
                                </v-tooltip>
                            </v-col>
                        </v-card-title>
                        <v-card-text>
                            
                            <table style="width: 100%; border: none; margin-top: 10px;">
                                <tr>
                                    <td></td>
                                    <td>Calculated</td>
                                    <td>Paid</td>
                                    <td>Remaining</td>
                                </tr>

                                <tr v-for="(itemPayment, index) in payment.listPaymentDetails" :key="index">
                                    <td :style="getValueColor(itemPayment)"><span style="color: gray !important;">[{{ itemPayment.parcelNumber }}]. </span> {{ itemPayment.percentage }}% {{ itemPayment.description }}</td>
                                    <td :style="getValueColor(itemPayment)"> {{ itemPayment.valueCalculatedFormatted }}</td>
                                    <td :style="getValueColor(itemPayment)"> {{ itemPayment.valueFormatted }}</td>
                                    <td :style="getValueColor(itemPayment)"> {{ itemPayment.remainingValueFormatted }}</td>
                                    <td><v-icon v-if="getValueColor(itemPayment) != alertColor" small color="var(--color__main)">mdi-check-circle-outline</v-icon></td>
                                </tr>

                                <tr>
                                    <td class="grandTotal">Total Paid</td>
                                    <td class="grandTotal">{{ payment.totalPaidFormatted }}</td>
                                    <td class="grandTotal"></td>
                                    <td class="grandTotal"></td>
                                    <td class="grandTotal"></td>
                                </tr>
                                <tr>
                                    <td class="grandTotal">Balance</td>
                                    <td class="grandTotal">{{ payment.balanceValueFormatted }}</td>
                                    <td class="grandTotal"></td>
                                    <td class="grandTotal"></td>
                                    <td class="grandTotal"></td>
                                </tr>
                            </table>
                            
                        </v-card-text>

                    </v-card>
                    
                </v-card-text>

                
                <v-card-text v-if="hasAnyTeam">

                    <v-card
                        class="mx-auto"
                    >
                        <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                            <v-col 
                                cols="9"
                                lg="9"
                                md="9"
                                sm="9"
                            >
                                Team
                            </v-col>
                            <v-col 
                                style="text-align: right;"
                                cols="3"
                                lg="3"
                                md="3"
                                sm="3"
                            >
                                <v-tooltip
                                    left
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            v-on="on"
                                            large
                                            color="var(--color__main)"
                                            @click="showDialogChooseTeam()"
                                        >
                                            mdi-microsoft-teams
                                        </v-icon>
                                    </template>
                                    <span>Manage Team</span>
                                </v-tooltip>
                            </v-col>
                        </v-card-title>
                        <v-card-text>
                            
                            <v-row style="margin-top: 20px">

                                <v-col 
                                    cols="12"
                                    lg="2"
                                    md="3"
                                    sm="12"
                                >
                                    <label>Drafter Team</label>
                                    <div class="techName" v-for="(itemTech, indexTeam) in listTeamDrafter" :key="indexTeam">
                                        - {{ getTechName(itemTech) }} <br />
                                    </div>
                                </v-col>
                                
                                <v-col 
                                    cols="12"
                                    lg="2"
                                    md="3"
                                    sm="12"
                                >
                                    <div class="teamTitle"><label>Permitting Team</label></div>
                                    <div class="techName" v-for="(itemTech, indexTeam) in listTeamPermit" :key="indexTeam">
                                        - {{ getTechName(itemTech) }} <br />
                                    </div>
                                </v-col>
                                
                                <v-col 
                                    cols="12"
                                    lg="2"
                                    md="3"
                                    sm="12"
                                >
                                    <div class="teamTitle"><label>Electric Team</label></div>
                                    <div class="techName" v-for="(itemTech, indexTeam) in listTeamElectric" :key="indexTeam">
                                        - {{ getTechName(itemTech) }} <br />
                                    </div>
                                </v-col>
                                
                                <v-col 
                                    cols="12"
                                    lg="2"
                                    md="3"
                                    sm="12"
                                >
                                    <div class="teamTitle"><label>Plumbing Team</label></div>
                                    <div class="techName" v-for="(itemTech, indexTeam) in listTeamPlumbing" :key="indexTeam">
                                        - {{ getTechName(itemTech) }} <br />
                                    </div>
                                </v-col>
                                
                                <v-col 
                                    cols="12"
                                    lg="2"
                                    md="3"
                                    sm="12"
                                >
                                    <div class="teamTitle"><label>Gas Team</label></div>
                                    <div class="techName" v-for="(itemTech, indexTeam) in listTeamGas" :key="indexTeam">
                                        - {{ getTechName(itemTech) }} <br />
                                    </div>
                                </v-col>
                                
                                <v-col 
                                    cols="12"
                                    lg="2"
                                    md="3"
                                    sm="12"
                                >
                                    <div class="teamTitle"><label>Engineering Team</label></div>
                                    <div class="techName" v-for="(itemTech, indexTeam) in listTeamEngineer" :key="indexTeam">
                                        - {{ getTechName(itemTech) }} <br />
                                    </div>
                                </v-col>
                            </v-row>
                            
                        </v-card-text>

                    </v-card>
                    
                </v-card-text>
            </v-col>
        </v-row>

        <v-row
            v-if="showColorSelectionMessage == true"
        >
            <v-col 
                cols="12"
                lg="12"
                md="12"
                sm="12"
                style="text-align: center; padding: 30px !important;"
            >
                <span style="font-size: 20px; color: var(--color__red); font-style: italic;">The notes section for each selection should not be used for installation instructions or for requesting changes to color choices. This section is intended solely for adding notes relevant to the product itself</span>
            </v-col>
        </v-row>

        <v-row
            v-if="showProjects == true && listProjects.length > 0"
        >
            <v-col 
                cols="12"
                lg="12"
                md="12"
                sm="12"
                style="padding: 0px !important;"
            >
                <v-card-text>
                    <v-card
                        class="mx-auto"
                    >
                        <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                            Choose Project
                        </v-card-title>
                        <v-card-text>

                            <v-row>
                                <v-col
                                    cols="10"
                                    :lg="showButtonsCreateEditProject == true ? 10 : 12"
                                    md="10"
                                    sm="10"
                                >
                                    <v-combobox
                                        style="margin-top: 10px; height: 30px;"
                                        v-model="projectSelected"
                                        :items="listProjects"
                                        item-text="nameWithVersion"
                                        item-value="id"
                                        clearable
                                        outlined
                                        @change="updateProject()"
                                        dense
                                    ></v-combobox>
                                </v-col>

                                <v-col 
                                    style="margin-top: 5px;"
                                    cols="2"
                                    lg="2"
                                    md="2"
                                    sm="2"
                                >
                                    <v-tooltip 
                                        v-if="showButtonsCreateEditProject == true"
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn 
                                                style="width: 45px;"
                                                class="btnActions"
                                                outlined
                                                fab
                                                x-small
                                                v-on="on"
                                                color="var(--color__main) !important"
                                                small
                                                @click="showCreateUpdateProject(true)"
                                            >
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Add New Project</span>
                                    </v-tooltip>

                                    <v-tooltip 
                                        v-if="showButtonsCreateEditProject == true"
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn 
                                                style="width: 45px;"
                                                class="btnActions"
                                                outlined
                                                fab
                                                x-small
                                                v-on="on"
                                                color="var(--color__green) !important"
                                                small
                                                :disabled="projectSelected == null || projectSelected == undefined"
                                                @click="showCreateUpdateProject(false)"
                                            >
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit Project Selected</span>
                                    </v-tooltip>

                                    <v-tooltip 
                                        v-if="showButtonsCreateEditVersion == true"
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn 
                                                style="width: 45px;"
                                                class="btnActions"
                                                outlined
                                                fab
                                                x-small
                                                v-on="on"
                                                color="var(--color__cinza_escuro) !important"
                                                small
                                                :disabled="projectSelected == null || projectSelected == undefined"
                                                @click="showListProjectVersions(false)"
                                            >
                                                <v-icon>mdi-cog-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Manage Versions</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row> 
                        </v-card-text>

                    </v-card>
                    
                </v-card-text>
            </v-col>
        </v-row>

        <v-row
            v-if="showAddress == true"
        >
            <v-col 
                cols="12"
                lg="12"
                md="12"
                sm="12"
                style="padding: 0px !important;"
            >
                <v-card-text>
                    <v-card
                        class="mx-auto"
                    >
                        <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                            Choose Address
                        </v-card-title>
                        <v-card-text>
                    
                            <v-row>
                                <v-col 
                                    cols="12"
                                    lg="12"
                                    md="12"
                                    sm="12"
                                >
                                    <v-combobox
                                        v-model="addressSelected"
                                        :items="listAddress" 
                                        :rules=[validations.required]
                                        item-text="address"
                                        item-value="id"
                                        clearable
                                        outlined
                                        @change="updateAddress()"
                                        dense
                                    ></v-combobox>
                                </v-col>
                            </v-row>
                        </v-card-text>

                    </v-card>
                    
                </v-card-text>
            </v-col>
        </v-row>

        <!-- Project Dialog (Add or Edit) -->
        <v-dialog
            v-if="fromTrackerPage == false"
            v-model="showDialogProject"
            transition="dialog-top-transition"
            persistent
            width="800"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
        
            <v-card>
                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                    Project
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-form
                        ref="formProject"
                        v-model="validFormProject"
                        lazy-validation
                    >
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="6"
                                md="6"
                                sm="12"
                            >
                                <label>Type of work</label>
                                <v-combobox
                                    v-model="serviceProject.typeWorkSelected"
                                    :items="listTypeWork" 
                                    :rules=[validations.required]
                                    item-text="kindWorkDescription"
                                    item-value="id"
                                    clearable
                                    outlined
                                    dense
                                ></v-combobox>
                            </v-col>

                            <v-col 
                                v-if="showOptionNewProject"
                                cols="12"
                                lg="6"
                                md="6"
                                sm="12"
                            >
                                <label>Type of Project</label>
                                <v-combobox
                                    v-model="serviceProject.typeProjectSelected"
                                    :items="listTypeNewProject" 
                                    :rules=[validations.required]
                                    item-text="description"
                                    item-value="id"
                                    clearable
                                    outlined
                                    dense
                                ></v-combobox>
                            </v-col>
                        </v-row>
                        
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Do you have a Survey?</label>
                                <v-radio-group 
                                    v-model="serviceProject.isSurvey" 
                                    row
                                >
                                    <v-radio
                                        label="Yes"
                                        :value="1"
                                        color="var(--color__main)"
                                    ></v-radio>
                                    <v-radio
                                        label="No"
                                        :value="0"
                                        color="var(--color__main)"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Name</label>
                                <v-text-field
                                    v-model="serviceProject.name" 
                                    :rules=[validations.required]
                                    single-line
                                    outlined
                                    dense
                                >
                                </v-text-field>
                            </v-col>                       
                        </v-row>
                    
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Address</label>
                                <v-combobox
                                    v-model="serviceProject.addressSelected"
                                    :items="listAddress" 
                                    :rules=[validations.required]
                                    item-text="address"
                                    item-value="id"
                                    clearable
                                    outlined
                                    dense
                                ></v-combobox>
                            </v-col>
                        </v-row>
                        
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Notes</label>
                                <v-textarea
                                    v-model="serviceProject.notes"
                                    single-line
                                    rows="4"
                                    row-height="30"
                                    outlined
                                >
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div style="width: 100%; text-align: center;">
                        <v-btn
                            class="mx-2"
                            v-if="serviceProject.id != 0 && listProjects.length > 1"
                            style="background-color: var(--color__silver) !important; color: #ffffff !important"
                            outlined
                            @click="confirmRemoveProject()"
                        >
                            Remove
                        </v-btn>

                        <v-btn
                            class="mx-2 buttonCancelDialog"
                            style=""
                            outlined
                            @click="showDialogProject = false"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            class="mx-2"
                            outlined
                            @click="saveProject()"
                        >
                            Save
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>  

        <!-- Manage Versions -->
        <v-dialog
            v-if="fromTrackerPage == false"
            v-model="showDialogProjectVersion"
            transition="dialog-top-transition"
            persistent
            width="800"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
        
            <v-card>
                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                    Manage Versions
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                            
                    <table style="width: 100%; border: none; margin-top: 10px; font-size: 17px">
                        <tr>
                            <td class="header">Number</td>
                            <td class="header">Name</td>
                            <td class="header">Actions</td>
                        </tr>
                        <tr v-for="(itemVersion, index) in listVersions" :key="index" :style="itemVersion.currentVersion == 1 ? 'font-weight: bold;' : ''">
                            <td>{{ itemVersion.versionFormatted }}</td>
                            <td>{{ itemVersion.versionName }} <v-icon v-if="itemVersion.currentVersion == 1" small color="green">mdi-check-circle-outline</v-icon></td>
                            <td>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn 
                                            class="btnActions"
                                            style="width: 30px; height: 30px !important;"
                                            icon 
                                            outlined
                                            v-on="on" 
                                        >
                                            <v-icon small @click="confirmSettingCurrentVersion(itemVersion.id, itemVersion.versionName)">mdi-swap-horizontal</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Switch to this version</span>
                                </v-tooltip>

                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn 
                                            class="btnActions"
                                            style="width: 30px; height: 30px !important;"
                                            icon 
                                            outlined
                                            v-on="on" 
                                        >
                                            <v-icon small @click="showCreateUpdateProjectVersion(false, itemVersion.id)">mdi-pencil</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edit</span>
                                </v-tooltip>

                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn 
                                            class="btnActions"
                                            :style="listVersions.length <= 1 ? 'width: 30px; height: 30px !important;' : 'width: 30px; height: 30px !important; color: var(--color__red) !important;'"
                                            large
                                            icon 
                                            outlined
                                            v-on="on"
                                            :disabled="listVersions.length <= 1"
                                        >
                                            <v-icon 
                                                small 
                                                @click="confirmProjectVersionDelete(itemVersion.id, itemVersion.versionName)"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Delete</span>
                                </v-tooltip>                                
                            </td>
                        </tr>
                    </table>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div style="width: 100%; text-align: center;">

                        <v-btn
                            class="mx-2 buttonCancelDialog"
                            style="background-color: var(--color__silver) !important; color: #ffffff !important"
                            outlined
                            @click="showDialogProjectVersion = false"
                        >
                            Back
                        </v-btn>

                        <v-btn
                            class="mx-2"
                            outlined
                            @click="showCreateUpdateProjectVersion(true, 0)"
                        >
                            Save Snapshot
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Manage Versions - Add or Edit -->
        <v-dialog
            v-if="isProfileAdmin"
            v-model="showDialogProjectVersionAddEdit"
            transition="dialog-top-transition"
            persistent
            width="800"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
        
            <v-card>
                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                    Versions
                </v-card-title>

                <v-card-text style="margin-top: 20px;">

                    <v-form
                        ref="formProjectVersion"
                        v-model="validFormProjectVersionAddEdit"
                        lazy-validation
                    >
                        <v-row
                            v-if="serviceProjectVersion.id == 0"
                        >
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <v-switch
                                    v-model="serviceProjectVersion.startFromScratch"
                                    label="Start from scratch"
                                    color="var(--color__main)"
                                >
                                </v-switch>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Version Name</label>
                                <v-text-field
                                    v-model="serviceProjectVersion.versionName" 
                                    :rules=[validations.required]
                                    single-line
                                    outlined
                                    dense
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Notes</label>
                                <v-textarea
                                    v-model="serviceProjectVersion.versionNotes"
                                    single-line
                                    rows="4"
                                    row-height="30"
                                    outlined
                                >
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div style="width: 100%; text-align: center;">

                        <v-btn
                            class="mx-2 buttonCancelDialog"
                            outlined
                            @click="showDialogProjectVersionAddEdit = false"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            class="mx-2"
                            outlined
                            @click="saveProjectVersion()"
                        >
                            Save
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Manage Versions - Add or Edit -->
        <v-dialog
            v-model="showQRCode"
            transition="dialog-top-transition"
            persistent
            width="300"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                    QR Code
                </v-card-title>

                <v-card-text style="margin-top: 20px; text-align: center;">
                    <qrcode-vue
                        :value="serviceRequest.customerUrl"
                        :size="200"
                        level="H"
                    />
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div style="width: 100%; text-align: center;">
						<v-btn
							class="mx-2 v-btn-large dialogButtonDismiss"
							outlined
							@click="showQRCode = false"
						>
							Dismiss
						</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        /> 
        
        <DialogSelectSupervisor
            v-if="isProfileAdmin"
            :id="dialogSupervisor.id"
            :setSupervisor="dialogSupervisor.setSupervisor"
            :idStatusToUpdate="dialogSupervisor.idStatusToUpdate"
            v-on:methodConfirmToCall="dialogSupervisor.methodConfirm"
            :showDialogSupervisor.sync="dialogSupervisor.show"
        />
        
        <DialogUpdatePermitFee
            v-if="isProfileAdmin"
            :id="dialogPermitFee.id"
            :setPermitFee="dialogPermitFee.setPermitFee"
            v-on:methodConfirmToCall="dialogPermitFee.methodConfirm"
            :showDialogPermitFee.sync="dialogPermitFee.show"
        />
        
        <DialogUpdateEstimatedBudget
            v-if="canEditEstimatedBudget"
            :id="dialogEstimatedBudget.id"
            :setEstimatedBudget="dialogEstimatedBudget.setEstimatedBudget"
            v-on:methodConfirmToCall="dialogEstimatedBudget.methodConfirm"
            :showDialogEstimatedBudget.sync="dialogEstimatedBudget.show"
        />

        <DialogUpdateContractDate
            v-if="canEditEstimatedBudget"
            :id="dialogContractDate.id"
            :setContractDate="dialogContractDate.setContractDate"
            v-on:methodConfirmToCall="dialogContractDate.methodConfirm"
            :showDialogContractDate.sync="dialogContractDate.show"
        />

        <DialogUpdateSalesPerson
            v-if="isProfileAdmin"
            :id="dialogSalesPerson.id"
            :setSalesPerson="dialogSalesPerson.setSalesPerson"
            v-on:methodConfirmToCall="dialogSalesPerson.methodConfirm"
            :showDialogSalesPerson.sync="dialogSalesPerson.show"
        />

        <DialogManagePayments
            v-if="isProfileAdmin"
            :id="dialogManagePayments.id"
            v-on:methodConfirmToCall="dialogManagePayments.methodConfirm"
            :showDialogManagePayments.sync="dialogManagePayments.show"
        />

        <ViewMap 
            v-on:methodConfirmToCall="dialogViewMap.methodConfirm"
            :showDialogMap.sync="dialogViewMap.show"
            :idAux="dialogViewMap.idAux"
            :address="dialogViewMap.address"
            :latitude="dialogViewMap.latitude"
            :longitude="dialogViewMap.longitude"
            :params="dialogViewMap.params"
        />

        <DialogUpdateYesNoIsRequired
            :id="dialogYesNoIsRequired.id"
            :idAux="dialogYesNoIsRequired.idAux"
            :type="dialogYesNoIsRequired.type"
            :setYesNoIsRequired="dialogYesNoIsRequired.setYesNoIsRequired"
            :financeData="dialogYesNoIsRequired.financeData"
            v-on:methodConfirmToCall="dialogYesNoIsRequired.methodConfirm"
            :showDialogYesNoIsRequired.sync="dialogYesNoIsRequired.show"
        />

        <DialogChooseTeam
            :idAux="dialogChooseTeam.idAux"
            :idServiceProject="dialogChooseTeam.idServiceProject"
            v-on:methodConfirmToCall="dialogChooseTeam.methodConfirm"
            :showDialogTeam.sync="dialogChooseTeam.show"
        />
	</div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import { required } from "@/utilities/Rules";
    import { formaterDecimalBR } from '@/utilities/Utils';
    import ActionDialog from "@/components/Layout/ActionDialog";
    import { TYPE_DOCUMENT, TYPE_ATTACHMENT } from "@/utilities/Enums";
    import { orderBy } from '@/utilities/Utils';
    import { URL_ATTACHMENT, URL_ATTACHMENT_LOAD_CALCULATION } from "@/utilities/Enums";
    import DialogSelectSupervisor from "@/components/Services/DialogSelectSupervisor";
    import DialogUpdatePermitFee from "@/components/Services/DialogUpdatePermitFee";
    import DialogUpdateEstimatedBudget from "@/components/Services/DialogUpdateEstimatedBudget";
    import DialogUpdateContractDate from "@/components/Services/DialogUpdateContractDate";
    import DialogUpdateSalesPerson from "@/components/Services/DialogUpdateSalesPerson";
    import DialogManagePayments from "@/components/Services/DialogManagePayments";
    import DialogUpdateYesNoIsRequired from "@/components/Services/DialogUpdateYesNoIsRequired";
    import DialogChooseTeam from '@/components/Services/DialogChooseTeam.vue';
    import JobInformationDocuments from "@/components/Services/JobInformationDocuments";
    import ViewMap from "@/components/Services/ViewMap";
    import { TYPE_OF_WORK, CATEGORY_TEAM } from "@/utilities/Enums";
    import QrcodeVue from 'qrcode.vue'

	export default {

        components: {
            ActionDialog,
            DialogSelectSupervisor,
            DialogUpdatePermitFee,
            DialogUpdateEstimatedBudget,
            DialogUpdateContractDate,
            DialogUpdateSalesPerson,
            DialogManagePayments,
            DialogUpdateYesNoIsRequired,
            JobInformationDocuments,
            DialogChooseTeam,
            ViewMap,
            QrcodeVue
        },

        mixins: [Helpers],

        props: {
			
            id: {
                type: Number,
                default: 0
            },

            guid: {
                type: String,
                default: ""
            },

			showJobInformation: {
				default: true
			},
            
			showJobSummary: {
				default: false
			},
            
			showProjects: {
				default: true
			},

			showCustomerURL: {
				default: true
			},

			showReviewReason: {
				default: false
			},

			showAddress: {
				default: false
			},

			showButtonsCreateEditProject: {
				default: true
			},

			showButtonsCreateEditVersion: {
				default: true
			},

			showClassification: {
				default: false
			},

			showDisabledClassification: {
				default: false
			},

            project: {
                default: null
            },

            refreshJob: {
                default: false
            },

            showQuickAccess: {
                default: true
            },

            canChangeSupervisor: {
                default: false
            },

            showQuickAccessAsDocument: {
                default: false
            },

            showPayments: {
                default: false
            },

            fromTrackerPage: {
                default: false
            },

            managePayments: {
                default: false
            },

            showColorSelectionMessage: {
                default: false
            }
		},

		
        data: () => ({
            
            URL_ATTACHMENT,
            URL_ATTACHMENT_LOAD_CALCULATION,
			
            serviceRequest: {
                id: 0,
                userNameRegister: "",
                dateRegisterFormatted: "",
                customerSelected: {
                    name: ""
                },
                addressSelected: {
                    address: ""
                },
                userResponsibleSelected: {
                    name: ""
                },
                customerUrl: ""
            },

            listProjects: [],
            projectSelected: null,
            showDialogProject: false,
            validFormProject: true,
            
            listVersions: [],
            showDialogProjectVersion: false,
            showDialogProjectVersionAddEdit: false,
            validFormProjectVersionAddEdit: true,

            listTypeWork: [],

            listTypeNewProject: [
                { id: 1, description: 'New Pool' },
                { id: 2, description: 'BBQ' },
                { id: 3, description: 'Outdoor' },
            ],

            serviceProject: {
                id: 0,
                idServiceProjectReference: 0,
                idCustomer: 0,
                typeWorkSelected: {
                    id: 3,
                    kindWorkDescription: 'Service'
                },
                typeProjectSelected: null,
                idKindWork: 3,
                pool: true,
                bbq: false,
                pergola: false,
                isSurvey: 1,
                step: 1,
                name: "",
                notes: "",
                addressSelected: null,
            },

            serviceProjectVersion: {
                idServiceProject: 0,
                idServiceProjectReference: 0,
                startFromScratch: false,
                idService: 0,
                versionName: '',
                versionNotes: ''
            },

            addressSelected: null,
            listAddress: [],

            grandTotal: "$ 0,00",
            discount: "$ 0.00",
            permitFee: "$ 0.00",

            classificationSelected: null,
            listClassification: [
                { id: 1,  description: '1 - Highest Priority' },
                { id: 2,  description: '2 - High Priority' },
                { id: 3,  description: '3 - Medium Priority' },
                { id: 4,  description: '4 - Low Priority' }
            ],
            
            surveyFileId: 0,
            surveyFileType: 'application/pdf',
            surveyFileName: '',
            
            poolStudioFileId: 0,
            poolStudioFileType: 'application/pdf',
            poolStudioFileName: '',
            
            colorSelectionFileId: 0,
            colorSelectionFileType: 'application/pdf',            
            colorSelectionFileName: '',

            addendumListFiles: [],
            listAddendum: [],
            permittingListFiles: [],
            listCustomItems: [],

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            dialogSupervisor: {
                id: 0,
                setSupervisor: null,
                idStatusToUpdate: 0,
                show: false,
                methodConfirm: ( () => {} ),
            },

            dialogPermitFee: {
                id: 0,
                setPermitFee: null,
                show: false,
                methodConfirm: ( () => {} ),
            },

            dialogEstimatedBudget: {
                id: 0,
                setEstimatedBudget: null,
                show: false,
                methodConfirm: ( () => {} ),
            },

            dialogContractDate: {
                id: 0,
                setContractDate: null,
                show: false,
                methodConfirm: ( () => {} ),
            },

            dialogSalesPerson: {
                id: 0,
                setSalesPerson: null,
                show: false,
                methodConfirm: ( () => {} ),
            },

            dialogManagePayments: {
                id: 0,
                show: false,
                methodConfirm: ( () => {} ),
            },

            dialogViewMap: {
                show: false,
                idAux: 0,
                address: "",
                latitude: "",
                longitude: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            dialogYesNoIsRequired: {
                id: 0,
                idAux: 0,
                type: '',
                setYesNoIsRequired: null,
                financeData: null,
                show: false,
                methodConfirm: ( () => {} ),
            },

            listTeamDrafters: [],
            listTeamPermit: [],
            listTeamElectric: [],
            listTeamPlumbing: [],
            listTeamGas: [],
            listTeamEngineer: [],
            dialogChooseTeam: {
                idAux: 0,
                idServiceProject: 0,
                show: false,
                methodConfirm: ( () => {} ),
            },

            validations: {
                required: required
            },

            og: Math.pow(10, 2),

            payment: null,
            alertColor: "color: var(--color__alert) !important;",
            mainColor: "color: var(--color__main) !important;",

            showQRCode: false,
            
            TYPE_OF_WORK
		}),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            showOptionNewProject() {

                if (this.serviceProject.typeWorkSelected != null && 
                    this.serviceProject.typeWorkSelected != undefined) {
                    return this.serviceProject.typeWorkSelected.id == this.TYPE_OF_WORK.REMODEL || 
                           this.serviceProject.typeWorkSelected.id == this.TYPE_OF_WORK.NEW_PROJECT;
                }
                else {
                    return false;
                }
            },

            isProfileAdmin() {
                if (this.fromTrackerPage == true) {
                    return false;
                }
                else {
                    return (this.profileLoaded == true && 
                            this.userLoggedGetters.profile.systemAdmin != null && 
                            this.userLoggedGetters.profile.systemAdmin == 1) ||
                           (this.userLoggedGetters != null && this.userLoggedGetters.id == 0)
                }
                
            },

            isSalesPerson() {
                return this.profileLoaded == true && 
                       this.userLoggedGetters.profile.budgetControl != null && 
                       this.userLoggedGetters.profile.budgetControl == 1;
            },

            getConstructionSupervisorName() {

                return this.projectSelected != null && 
                       this.projectSelected != undefined &&
                       this.projectSelected.constructionSupervisorName != null &&
                       this.projectSelected.constructionSupervisorName != undefined ? 
                       this.projectSelected.constructionSupervisorName.toString().trim() : '';
            },

            canEditClassification() {
                return this.showDisabledClassification == true ||
                       this.userLoggedGetters.profile.editJobClassification == 0
            },
            
            isServiceType() {
                return this.projectSelected != null && 
                       this.projectSelected != undefined &&
                       this.projectSelected.typeWorkSelected != null &&
                       this.projectSelected.typeWorkSelected != undefined &&
                       this.projectSelected.typeWorkSelected.id == this.TYPE_OF_WORK.SERVICE;
            },

            hasCustomItems() {
                return this.listCustomItems != null && 
                       this.listCustomItems != undefined && 
                       this.listCustomItems.length > 0;
            },

            grandTotalProductsCustomItems() {
                if (this.hasCustomItems == true) {
                    let total = 0;
                    this.listCustomItems.forEach(item => {
                        total += parseFloat(item.total);
                    });
                    return {
                        "unFormatted": total,
                        "formatted": `$ ${formaterDecimalBR(total.toFixed(2))}`
                    }
                }
                else {
                    return { 
                        "unFormatted": 0,
                        "formatted": "$ 0.00"
                    };
                }
            },

            profileLoaded() {
                return this.userLoggedGetters != null && 
                        this.userLoggedGetters != undefined && 
                        this.userLoggedGetters.profile != null &&
                        this.userLoggedGetters.profile != undefined
            },

            canEditGeoCoding() {
                return this.profileLoaded == true &&
                        this.userLoggedGetters.profile.canEditGeoCoding == 1;
            },

            canEditEstimatedBudget() {
                return this.profileLoaded == true &&
                        this.userLoggedGetters.profile.canEditEstimatedBudget == 1;
            },

            hasAnyTeam() {
                return this.listTeamDrafters?.length > 0 ||
                       this.listTeamPermit?.length > 0 ||
                       this.listTeamElectric?.length > 0 ||
                       this.listTeamPlumbing?.length > 0 ||
                       this.listTeamGas?.length > 0 ||
                       this.listTeamEngineer?.length > 0;
            }
        },

        watch: {
            async "id"() {
				this.getRegister();
            },

            async "refreshJob"() {
				this.getRegister();
            },

            async "project"() {

                if (this.project != null && this.project != undefined) {
                    this.projectSelected = this.project;
                }
            }
        },

        methods: {

            getValueColor(itemPayment) {
                if (itemPayment.valueFormatted != itemPayment.valueCalculatedFormatted) {
                    return this.alertColor;
                }
                else {
                    return this.mainColor;
                }
            },

            async getIDProject() {

                let idServiceProject = 0;

                if (this.projectSelected != null && this.projectSelected != null) {
                    idServiceProject = this.projectSelected.id;
                }

                return idServiceProject;
            },

            getIDProjectFormatted() {

                let idServiceProject = '';

                if (this.projectSelected != null && this.projectSelected != null) {
                    idServiceProject = this.projectSelected.idFormatted;
                }

                return idServiceProject;
            },
			
            async updateProject(checkValidation = false) {

                if (this.projectSelected != null && this.projectSelected != undefined) {
                    this.listProjects.forEach(itemProject => {
                        if (itemProject.id == this.projectSelected.id) {
                            this.projectSelected = itemProject;

                            let itemClassification = this.listClassification.filter(cla => cla.id == itemProject.classification)[0];
                            
                            if (itemClassification != null && itemClassification != undefined) {
                                this.classificationSelected = itemClassification;
                            }

                            this.getAttachments();
                        }
                    })

                    await this.getCustomItems();
                }

				this.$emit('changeProject', this.projectSelected, this.listProjects, checkValidation)
            },
			
            async updateAddress() {

                if (this.addressSelected != null && this.addressSelected != undefined) {
                    this.listAddress.forEach(itemAddress => {
                        if (itemAddress.id == this.addressSelected.id) {
                            this.addressSelected = itemAddress
                        }
                    })
                }

				this.$emit('changeAddress', this.addressSelected, this.listAddress)
            },

            async updateClassification() {
                
                const idServiceProject = await this.getIDProject();

                let classification = '';

                if (this.classificationSelected != null && this.classificationSelected != undefined) {
                    classification = this.classificationSelected.id;
                }

                if (classification != null && classification != undefined) {

                    this.$store.dispatch("serviceModule/UpdateClassification", { idServiceProject, classification });
                }
            },

            async getRegister() {

                this.showLoading();

                if (this.fromTrackerPage == true) {
                    const response = await this.$store.dispatch("serviceModule/GetByGuid", this.guid);
                    if (response.success) {                        
                        this.serviceRequest = response.result;
                    }
                }
                else  {
                    const response = await this.$store.dispatch("serviceModule/GetById", this.id);

                    this.serviceRequest = response.result;

                    const listTypeWork = await this.$store.dispatch("serviceModule/ListTypeOfWorks");
                    this.listTypeWork = listTypeWork.filter(tow => tow.id >= 1);
                }

                await this.loadListProjects();

                if (this.showAddress) {
                    this.loadAddress();
                }

                if (this.showPayments == true) {

                    let listPayments = null;

                    if (this.fromTrackerPage == true) {
                    
                        const requestFilter = {
                            idService: 0,
                            guid: this.guid,
                            listPendingPayments: true
                        }

                        listPayments = await this.$store.dispatch("servicePaymentsModule/ListPayments", requestFilter);
                    }
                    else {
                        const requestFilter = {
                            idService: this.id,
                            guid: "",
                            listPendingPayments: true
                        }

                        listPayments = await this.$store.dispatch("servicePaymentsModule/ListPayments", requestFilter);
                    }

                    if (listPayments != null && listPayments != undefined) {
                        this.payment = listPayments[0];
                    }
                }

                this.hideLoading();
            },

            async loadListProjects(checkValidation = false) {

                if (this.fromTrackerPage == true) {
                    this.listProjects = await this.$store.dispatch("serviceModule/ListProjectByGuid", this.guid);
                }
                else {                    
                    this.listProjects = await this.$store.dispatch("serviceModule/ListProject", this.serviceRequest.id);
                }

                if (this.listProjects != null && this.listProjects != undefined) {
                    this.projectSelected = this.listProjects[0]
                }
                
                await this.updateProject(checkValidation);

                const idServiceProject = await this.getIDProject();
                this.listTechs();

                this.listAddendum = [];
                if (this.fromTrackerPage == true) {
                    const request = {
                        id: idServiceProject,
                        guid: this.guid
                    }
                    this.listAddendum = await this.$store.dispatch("serviceModule/ListAddendumByGuid", request);
                }
                else {                    
                    this.listAddendum = await this.$store.dispatch("serviceModule/ListAddendum", idServiceProject);
                }

                // this.grandTotal = `$ ${formaterDecimalBR( (grandTotal.toFixed(0) * this.og) / this.og )}`;
                // this.grandTotal = this.projectSelected?.grandTotalFormatted;
                this.grandTotal = this.serviceRequest.grandTotalFormatted;
            },

            getTotalAddendum(itemAddendum) {
                let totalAddendumJobTotal = 0;
                itemAddendum.forEach(itemProject => {
                    totalAddendumJobTotal += itemProject.total
                });
                return `$ ${formaterDecimalBR( (totalAddendumJobTotal.toFixed(2) * this.og) / this.og )}`;
            },

            async loadAddress() {
                
                if (this.serviceRequest.customerSelected != null && this.serviceRequest.customerSelected != undefined) {
                    let idCustomer = this.serviceRequest.customerSelected.id;
                    if (idCustomer != 0 && idCustomer != null && idCustomer != undefined) {
                        this.listAddress = await this.$store.dispatch(`customerModule/ListAddress`, idCustomer);

                        if (this.listAddress != null && this.listAddress != undefined && this.listAddress.length == 1) {
                            this.addressSelected = this.listAddress[0]
                        }

                        this.updateAddress();
                    }
                }
            },

            //PROJECT
            async showCreateUpdateProject(isNewProject) {

                this.showLoading();

                if (isNewProject) {
                    this.serviceProject = {
                        id: 0,
                        idServiceProjectReference: 0,
                        idCustomer: 0,
                        idKindWork: 3,
                        typeWorkSelected: {
                            id: this.TYPE_OF_WORK.SERVICE,
                            kindWorkDescription: 'Service'
                        },
                        typeProjectSelected: null,
                        pool: 0,
                        bbq: 0,
                        pergola: 0,
                        isSurvey: 1,
                        name: "",
                        notes: "",
                        addressSelected: null,
                    };
                }
                else {
                    const idServiceProject = await this.getIDProject();

                    const responseProject = await this.$store.dispatch("serviceModule/GetServiceProjectById", idServiceProject);

                    this.serviceProject = responseProject.result;

                    let typeProjectSelected = this.listTypeNewProject.filter(typ => typ.id == 1)[0];

                    if (this.serviceProject.bbq == 1) {
                        typeProjectSelected = this.listTypeNewProject.filter(typ => typ.id == 2)[0];
                    }
                    else if (this.serviceProject.pergola == 1) {
                        typeProjectSelected = this.listTypeNewProject.filter(typ => typ.id == 3)[0];
                    }

                    this.serviceProject.typeProjectSelected = typeProjectSelected
                }
                
                this.loadAddress();

                this.showDialogProject = true;

                this.hideLoading();
            },

            async getAttachments() {

                this.surveyFileId = 0;
                this.surveyFileName = '';
                this.poolStudioFileId = 0;
                this.poolStudioFileName = '';
                this.colorSelectionFileId = 0;
                this.colorSelectionFileName = '';

                const idServiceProject = await this.getIDProject();

                let listAttachments = await this.$store.dispatch("attachmentModule/GetAll", { typeAttachment: TYPE_ATTACHMENT.PROJECT.value, idKey: idServiceProject });

                //SURVEY
                let itemSessionDetailSurveyType = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.SURVEY.value)[0];
                if (itemSessionDetailSurveyType != null && itemSessionDetailSurveyType != undefined) {
                    this.surveyFileId = itemSessionDetailSurveyType.id;
                    this.surveyFileType = itemSessionDetailSurveyType.fileType;
                    this.surveyFileName = itemSessionDetailSurveyType.fileName;
                }

                let itemSessionDetailPoolStudioDXF = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.POOL_STUDIO_DXF.value)[0];
                if (itemSessionDetailPoolStudioDXF != null && itemSessionDetailPoolStudioDXF != undefined) {
                    this.poolStudioFileId = itemSessionDetailPoolStudioDXF.id;
                    this.poolStudioFileType = itemSessionDetailPoolStudioDXF.fileType;
                    this.poolStudioFileName = itemSessionDetailPoolStudioDXF.fileName;
                }

                listAttachments = await this.$store.dispatch("attachmentModule/GetAll", { typeAttachment: TYPE_ATTACHMENT.COLOR_SELECTION.value, idKey: idServiceProject });

                let listFilesColorSelection = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.COLOR_SELECTION.value);
                if (listFilesColorSelection != null && listFilesColorSelection != undefined) {
                    
                    let listColorSelectionFiles = [];

                    listFilesColorSelection.forEach(itemAddendum => {
                        listColorSelectionFiles.push({
                            id: itemAddendum.id,
                            fileName: itemAddendum.fileName,
                            fileType: itemAddendum.fileType,
                            createdOn: itemAddendum.dateRegisterFormatted,
                            userName: itemAddendum.userNameRegister
                        });
                    });

                    listColorSelectionFiles.sort((a, b) => { return orderBy(a, b, 1, 'id') });

                    if (listColorSelectionFiles.length > 0) {
                        this.colorSelectionFileId = listColorSelectionFiles[0].id;
                        this.colorSelectionFileType = listColorSelectionFiles[0].fileType;
                        this.colorSelectionFileName = listColorSelectionFiles[0].fileName;
                    }
                }

                listAttachments = await this.$store.dispatch("attachmentModule/GetAll", { typeAttachment: TYPE_ATTACHMENT.SERVICE.value, idKey: this.serviceRequest.id });

                if (listAttachments != null && listAttachments != undefined && listAttachments.length > 0) {
                    this.addendumListFiles = [];
                    const addendumListFiles = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.ADDENDUM.value);

                    if (addendumListFiles != null && addendumListFiles != undefined) {

                        addendumListFiles.forEach(itemFile => {

                            this.addendumListFiles.push({
                                id: itemFile.id,
                                fileType: itemFile.fileType,
                                fileName: itemFile.fileName,
                            });
                        })
                    }

                }
            },

            async confirmRemoveProject() {

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: `You will REMOVE this project [${this.serviceProject.name}] and all items and versions related to it, confirm your decision?`,
                    methodConfirm: this.removeProject,
                    params: 0
                };

            },

            async removeProject() {
                const result = await this.$store.dispatch("serviceModule/RemoveProject", { id: this.serviceProject.id, removeAllVersions: 1 });

                if (result.success === true) {
                    this.loadListProjects();
                    this.showToast("success", "Success!", result.message);
                    this.showDialogProject = false;
                    this.projectSelected = null;
                    return true;
                }
                else {
                    this.showToast("error", "Warning!", result.message);
                    return false;
                }
            },

            async saveProject() {

                await this.$refs.formProject.validate();
                
                if (
                    (this.serviceProject.typeWorkSelected != null && 
                     this.serviceProject.typeWorkSelected != undefined && 
                     this.serviceProject.typeWorkSelected.id != this.TYPE_OF_WORK.SERVICE) && 
                    (this.serviceProject.typeProjectSelected == null || 
                     this.serviceProject.typeProjectSelected == undefined)
                   ) 
                {
                    this.showToast("error", "Warning!", "You must select the type of project [Pool, BBQ or Outdoor]!");
                }
                else {
                    if (this.validFormProject === false) {
                        this.showToast("error", "Warning!", "There are inconsistencies in the project form. Please review!");
                        return false;
                    }
                    else {

                        if (this.serviceProject.typeWorkSelected != null && this.serviceProject.typeWorkSelected != undefined) {
                            this.serviceProject.idKindWork = this.serviceProject.typeWorkSelected.id;
                        }

                        if (this.serviceProject.typeProjectSelected != null && this.serviceProject.typeProjectSelected != undefined) {
                            if (this.serviceProject.typeProjectSelected.id == 1) {
                                this.serviceProject.pool = 1;
                                this.serviceProject.bbq = 0;
                                this.serviceProject.pergola = 0;
                            }
                            else if (this.serviceProject.typeProjectSelected.id == 2) {
                                this.serviceProject.pool = 0;
                                this.serviceProject.bbq = 1;
                                this.serviceProject.pergola = 0;
                            }
                            else if (this.serviceProject.typeProjectSelected.id == 3) {
                                this.serviceProject.pool = 0;
                                this.serviceProject.bbq = 0;
                                this.serviceProject.pergola = 1;
                            }
                        }

                        if (this.serviceProject.idKindWork == this.TYPE_OF_WORK.SERVICE) {
                            this.serviceProject.pool = 0;
                            this.serviceProject.bbq = 0;
                            this.serviceProject.pergola = 0;
                        }

                        this.serviceProject.idCustomer = this.serviceRequest.customerSelected.id;
                        this.serviceProject.isSameAddress = 1;
                        this.serviceProject.idService = this.id;

                        if (this.serviceProject.addressSelected != null && this.serviceProject.addressSelected != undefined) {
                            this.serviceProject.idAddress = this.serviceProject.addressSelected.id;
                        }

                        const result = await this.$store.dispatch("serviceModule/CreateUpdateServiceProject", this.serviceProject);

                        if (result.success === true) {
                            this.loadListProjects(true);
                            this.showToast("success", "Success!", result.message);
                            this.showDialogProject = false;
                            return true;
                        }
                        else {
                            this.showToast("error", "Warning!", result.message);
                            return false;
                        }
                    }
                }
            },
            
            //VERSION
            async loadVersions() {

                let idServiceProject = await this.getIDProject();

                this.listVersions = await this.$store.dispatch("serviceModule/ListProjectVersions", idServiceProject);

            },

            async showListProjectVersions() {

                this.showLoading();

                this.loadVersions();
            
                this.showDialogProjectVersion = true;

                this.hideLoading();
            },

            async showCreateUpdateProjectVersion(isNewVersion, idServiceProject) {

                this.showLoading();

                if (isNewVersion) {
                    this.serviceProjectVersion = {
                        id: idServiceProject,
                        idServiceProjectReference: await this.getIDProject(),
                        idService: this.id,
                        startFromScratch: false,
                        versionName: "",
                        versionNotes: "",
                    };
                }
                else {
                    let responseProject = await this.$store.dispatch("serviceModule/GetServiceProjectById", idServiceProject);

                    this.serviceProjectVersion = responseProject.result;
                }
                
                this.showDialogProjectVersionAddEdit = true;

                this.hideLoading();
            },

            async saveProjectVersion() {

                await this.$refs.formProjectVersion.validate();

                if (this.validFormProjectVersionAddEdit === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the version form. Please review!");
                    return false;
                }
                else {

                    const result = await this.$store.dispatch("serviceModule/CreateUpdateServiceProjectVersionSnapShot", this.serviceProjectVersion);

                    if (result.success === true) {
                        this.loadVersions();
                        this.showToast("success", "Success!", result.message);
                        this.showDialogProjectVersionAddEdit = false;
                        return true;
                    }
                    else {
                        this.showToast("error", "Warning!", result.message);
                        return false;
                    }
                }

            },

            async confirmProjectVersionDelete(idServiceProject, versionName) {

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: `You will REMOVE this version [${versionName}] and all items related to it, confirm your decision?`,
                    methodConfirm: this.removeVersion,
                    params: idServiceProject
                };
            },

            async removeVersion(idServiceProject) {
                const result = await this.$store.dispatch("serviceModule/RemoveProject", { id: idServiceProject, removeAllVersions: 0 });

                if (result.success === true) {
                    this.loadListProjects();
                    this.loadVersions();
                    this.showToast("success", "Success!", "Version deleted with successfully!");
                    this.showDialogProject = false;
                    this.projectSelected = null;
                    return true;
                }
                else {
                    this.showToast("error", "Warning!", result.message);
                    return false;
                }
            },

            async confirmSettingCurrentVersion(idServiceProject, versionName) {

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: `You will SWITCH for this version [${versionName}], confirm your decision?`,
                    methodConfirm: this.setCurrentVersion,
                    params: idServiceProject
                };
            },

            async setCurrentVersion(idServiceProject) {
                const result = await this.$store.dispatch("serviceModule/SetCurrentVersion", { idServiceProject, currentVersion: 1 });

                if (result.success === true) {
                    await this.loadListProjects();
                    await this.loadVersions();
                    this.showToast("success", "Success!", "Version switched with successfully!");
                    this.showDialogProject = false;
                    this.showDialogProjectVersion = false;
                    this.showDialogProjectVersionAddEdit = false;

                    this.listProjects.forEach(itemProject => {
                        if (itemProject.id == idServiceProject) {
                            this.projectSelected = itemProject;
                            this.updateProject();
                        }
                    })

                    return true;
                }
                else {
                    this.showToast("error", "Warning!", result.message);
                    return false;
                }
            },

            async showDialogSupervisor() {
                let idServiceProject = await this.getIDProject();

                let userSelected = null;

                if (this.projectSelected != null && this.projectSelected != undefined) {

                    userSelected = {
                        id: this.projectSelected.idUserSupervisor,
                        name: this.projectSelected.constructionSupervisorName
                    }
                }

                this.dialogSupervisor = {                    
                    id: idServiceProject,
                    setSupervisor: userSelected,
                    idStatusToUpdate: 18,
                    show: true,
                    methodConfirm: ( () => { this.getRegister() })
                }
            },

            async showDialogPermitFee() {
                this.dialogPermitFee = {                    
                    id: this.id,
                    setPermitFee: formaterDecimalBR(this.serviceRequest.permitFee),
                    show: true,
                    methodConfirm: ( () => { this.getRegister() })
                }
            },

            async showDialogEstimatedBudget() {
                this.dialogEstimatedBudget = {                    
                    id: this.id,
                    setEstimatedBudget: formaterDecimalBR(this.serviceRequest.estimatedBudget),
                    show: true,
                    methodConfirm: ( () => { this.getRegister() })
                }
            },

            async showDialogContractDate() {
                this.dialogContractDate = {                    
                    id: this.id,
                    setContractDate: this.serviceRequest.dateContractFormatted,
                    show: true,
                    methodConfirm: ( () => { this.getRegister() })
                }
            },

            async showDialogManagePayments() {
                this.dialogManagePayments = {                    
                    id: this.id,
                    show: true,
                    methodConfirm: ( () => { this.getRegister() })
                }
            },

            async showDialogSalesPerson() {

                this.dialogSalesPerson = {                    
                    id: this.id,
                    setSalesPerson: {
                        id: this.serviceRequest.userResponsibleSelected.id,
                        userName: this.serviceRequest.userResponsibleSelected.name
                    },
                    show: true,
                    methodConfirm: ( () => { this.getRegister() })
                }
            },

            async getCustomItems() {

                this.listCustomItems = [];
                const listCustomItems = await this.$store.dispatch("serviceModule/ListItemsCustomByService", this.id);

                if (listCustomItems != null && listCustomItems != undefined && listCustomItems.length > 0) {

                    listCustomItems.forEach(itemCustom => {
                        this.listCustomItems.push({
                            id: itemCustom.id,
                            description: itemCustom.description,
                            qty: itemCustom.qty,
                            priceFormatted: itemCustom.price,
                            price: itemCustom.price,
                            total: itemCustom.total,
                            note: itemCustom.note,
                            optional: itemCustom.optional,
                            optionalDescription: itemCustom.optionalDescription,
                            newRegister: false
                        });
                    });
                }
            },
            
            viewMapAddress() {

                let address = '';
                let latitude = '';
                let longitude = '';

                if (this.serviceRequest.addressSelected != null && this.serviceRequest.addressSelected != undefined) {
                    address = this.serviceRequest.addressSelected.address;
                    latitude = this.serviceRequest.addressSelected.latitude;
                    longitude = this.serviceRequest.addressSelected.longitude;
                }

                this.dialogViewMap = {
                    show: true,
                    idAux: Math.random(),
                    address,
                    latitude,
                    longitude,
                    methodConfirm: ( async (locationData) => {
                        if (locationData != null && locationData != undefined) {
                            
                            const requestUpdateLocation = {
                                id: this.serviceRequest.addressSelected.id,
                                latitude: locationData.latitude,
                                longitude: locationData.longitude
                            };

                            const result = await this.$store.dispatch("customerModule/UpdateLatitudeLongitude", requestUpdateLocation);

                            if (result.success === true) {
                                this.getRegister();
                                this.showToast("success", "Success!", result.message);
                            }
                            else {
                                this.showToast("error", "Warning!", result.message);
                            }
                        }
                    }),
                    params: null
                };
            },

            async showDialogYesNoIsRequired(type) {

                const yesNoIsRequired = 
                    type == 'ts' ? this.serviceRequest.techSpecIsRequired :
                    type == 'df' ? this.serviceRequest.draftingIsRequired :
                    type == 'pm' ? this.serviceRequest.permittingIsRequired :
                    type == 'se' ? this.serviceRequest.sendEmailForCustomerConstructionSteps :
                    type == 'lc' ? this.serviceRequest.loadCalculationRequired :
                    type == 'fi' ? this.serviceRequest.finance : null;

                let financeData = { amount: 0, who: '', paymentTerms: '' };

                if (type == 'fi') {
                    const resonseFinance = await this.$store.dispatch("serviceModule/GetServiceFinance", this.id);

                    if (resonseFinance != null && resonseFinance != undefined) {

                        const serviceFinance = resonseFinance.result;

                        financeData = {
                            amount: serviceFinance.amount ?? 0,
                            amountFormatted: serviceFinance.amountFormatted ?? '$ 0.00',
                            who: serviceFinance.who ?? '',
                            paymentTerms: serviceFinance.paymentTerms ?? ''
                        };
                    }
                }

                this.dialogYesNoIsRequired = {                    
                    id: this.id,
                    idAux: Math.random(),
                    type: type,
                    setYesNoIsRequired: yesNoIsRequired,
                    financeData,
                    show: true,
                    methodConfirm: ( () => { this.getRegister() })
                }
            },

            async showDialogChooseTeam() {
                this.showLoading();

                const idServiceProject = await this.getIDProject();

                this.dialogChooseTeam = {
                    idAux: Math.random(),
                    idServiceProject,
                    show: true,
                    methodConfirm: ( () => { this.getRegister() })
                }
            },

            async listTechs() {
                
                const idServiceProject = await this.getIDProject();
                
                const listTeam = await this.$store.dispatch("serviceModule/GetTeam", idServiceProject);

                const listTeamDrafter = listTeam.filter(item => item.categoryTeam == CATEGORY_TEAM.DRAFTER.value);
                const listTeamPermit = listTeam.filter(item => item.categoryTeam == CATEGORY_TEAM.PERMITTECH.value);
                const listTeamElectric = listTeam.filter(item => item.categoryTeam == CATEGORY_TEAM.ELECTRICTECH.value);
                const listTeamPlumbing = listTeam.filter(item => item.categoryTeam == CATEGORY_TEAM.PLUMBINGTECH.value);
                const listTeamGas = listTeam.filter(item => item.categoryTeam == CATEGORY_TEAM.GASTECH.value);
                const listTeamEngineer = listTeam.filter(item => item.categoryTeam == CATEGORY_TEAM.ENGINEER.value);

                const userName = 'Not yet assigned';

                if (listTeamDrafter != null && listTeamDrafter.length > 0) {
                    this.listTeamDrafter = listTeamDrafter;
                }
                else {
                    this.listTeamDrafter = [{ userName }]
                }

                if (listTeamPermit != null && listTeamPermit.length > 0) {
                    this.listTeamPermit = listTeamPermit;
                }
                else {
                    this.listTeamPermit = [{ userName }]
                }

                if (listTeamElectric != null && listTeamElectric.length > 0) {
                    this.listTeamElectric = listTeamElectric;
                }
                else {
                    this.listTeamElectric = [{ userName }]
                }

                if (listTeamPlumbing != null && listTeamPlumbing.length > 0) {
                    this.listTeamPlumbing = listTeamPlumbing;
                }
                else {
                    this.listTeamPlumbing = [{ userName }]
                }

                if (listTeamGas != null && listTeamGas.length > 0) {
                    this.listTeamGas = listTeamGas;
                }
                else {
                    this.listTeamGas = [{ userName }]
                }

                if (listTeamEngineer != null && listTeamEngineer.length > 0) {
                    this.listTeamEngineer = listTeamEngineer;
                }
                else {
                    this.listTeamEngineer = [{ userName }]
                }
            },

            getTechName(itemTech) {
                if (itemTech.userName != null && itemTech.userName != '') {
                    return itemTech.userName;
                }
                else if (itemTech.nameOther != null && itemTech.nameOther != '') {
                    return itemTech.nameOther;
                }
            },
        }
    };
</script>

<style scoped>

    .v-btn {
        height: 45px !important;
        width: 150px;
    }

    tbody > tr:hover {
        background-color: transparent !important;
    }

    .selectedRow, .selectedRow:hover {
        background-color: var(--color__main) !important;
        color: #fff;
        font-weight: bold;
    }

    td {
        padding: 3px;
    }

    .grandTotal {
        color: var(--color__main) !important; 
        font-size: 18px;
        font-weight: bold;
        padding-top: 10px;
    }

</style>